import { HttpParams } from "@angular/common/http";

export abstract class BaseService {
    private _CACHE: { [name: string]: { value: any; created: Date } } = {};
    
    /** In minutes */
    protected CACHE_EXPIRATION_TIME: number = 60;
  
    constructor() {}
  
    protected toHttpParams(object: any): HttpParams {
      let params = new HttpParams();
      for (let prop in object) {
        if (object[prop] !== undefined && object[prop] !== null) {
          if (object[prop] instanceof Array) {
            if ((<Array<any>>object[prop]).length !== 0) {
              object[prop].forEach((item: any) => {
                if (item !== undefined && item !== null && typeof item !== 'object') params = params.append(prop, item);
              });
            } else {
              params = params.append(`${prop}[]`, '')
            }
          } else if (object[prop] instanceof Date) {
            params = params.append(prop, (<Date>object[prop]).toISOString());
          } else {
            const filterObject = object[prop];
            if (prop === 'filters' && typeof filterObject === 'object') {
              for (let filterProp in filterObject) {
                if (filterObject[filterProp]) {
                  params = params.append(filterProp, filterObject[filterProp]);
                }
              }
            } else {
              params = params.append(prop, object[prop]);
            }
          }
        }
      }
      return params;
    }
  
    /**
     * Store data into cache
     * @param key cached data key
     * @param value cached data
     */
    protected setInCache<T>(key: string, value: T) {
      this._CACHE[key] = {
        value: value,
        created: new Date(),
      };
    }
  
    /**
     * Get cached data
     * @param key cached data key
     * @param {boolean=} ignoreExpiration if true, return cached data even if expired
     * @returns cached data if conservation time is not expired yet, 
     * returns undefined otherwise. 
     */
    protected getFromCache<T>(key: string, ignoreExpiration: boolean = false): T | undefined {
      if (this._CACHE[key] && this._CACHE[key].value && (ignoreExpiration || this.diff_minutes(new Date(), this._CACHE[key].created) < this.CACHE_EXPIRATION_TIME)) {
        return this._CACHE[key].value;
      }
      return undefined;
    }

    private diff_minutes(dt2: Date, dt1: Date) {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }
}